import { Divider } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

import { StarFilledIcon } from "@/Components/Icons/StarFilledIcon";
import { UnsuitableFilledIcon } from "@/Components/Icons/UnsuitableFilledIcon";

import AutoApproveBankCandiateFilledIcon from "../../../Icons/AutoApproveBankCandiateFilledIcon";

const CandidateStatusAndInfo = ({
  sortlisted,
  unsuitable,
  is_auto_booked_on_apply = 0,
  extraEle,
}) => {
  const { isPremiumAccount } = useSelector((state) => state.session);

  const renderDivider = () => (
    <Divider orientation="vertical" className="!border-[#C1C1C1]" />
  );
  const renderStatusIcon = () => {
    if (sortlisted) {
      return (
        <>
          <StarFilledIcon cls="text-[#FFD680] min-w-[14px] w-[14px] h-[14px]" />
          {renderDivider()}
        </>
      );
    }
    if (unsuitable) {
      return (
        <>
          <UnsuitableFilledIcon cls="text-[#E7585B] min-w-[14px] w-[14px] h-[14px]" />
          {renderDivider()}
        </>
      );
    }
    return null;
  };

  const renderAutoApproveIcon = () => {
    if (is_auto_booked_on_apply && isPremiumAccount) {
      return (
        <>
          <AutoApproveBankCandiateFilledIcon cls="w-[14px] h-[14px] text-green" />
          {renderDivider()}
        </>
      );
    }
    return null;
  };

  return (
    <div className="CandidateStatusAndInfo_Wrapper flex items-center gap-2">
      {renderStatusIcon()}
      {renderAutoApproveIcon()}
      {extraEle}
    </div>
  );
};

export default CandidateStatusAndInfo;
